export default __webpack_public_path__ + "static/media/packs_produced_icon_w.f8c785b8.png";